import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { ModelsState } from 'src_common/common/websocket2/ModelsState';

const getSelectionsResulted = (race: EventModel, models: ModelsState): Array<SelectionModel> | null => {
    for (const market of race.marketsAll) {
        const marketId = market.id;
        const marketModel = models.getMarket(marketId);
        if (marketModel === null) {
            return null;
        }
        return marketModel.selections.filter(
            (selection) => selection.state === 'settled' || selection.state === 'resulted'
        );
    }
    return null;
};

export const getTopSelectionsSorted = (
    race: EventModel,
    models: ModelsState,
    sport: 'horseracing' | 'greyhoundracing'
): Array<SelectionModel> | null => {
    const selectionsResulted = getSelectionsResulted(race, models);

    if (selectionsResulted === null) {
        return null;
    }

    const placesNumber = sport === 'horseracing' ? 4 : 3;

    return selectionsResulted
        .filter(
            (selection) =>
                selection.resultType === 'won' ||
                (selection.resultPlace !== null && selection.resultPlace <= placesNumber)
        )
        .sort((sel1, sel2) => {
            if (sel1.resultType === 'won') {
                return -1;
            }
            if (sel2.resultType === 'won') {
                return 1;
            }
            if (sel1.resultPlace === null) {
                return 1;
            }
            if (sel2.resultPlace === null) {
                return -1;
            }
            return sel1.resultPlace - sel2.resultPlace;
        });
};
